import { render, staticRenderFns } from "./OfficeNvR.vue?vue&type=template&id=34a60abf&"
import script from "./OfficeNvR.vue?vue&type=script&lang=js&"
export * from "./OfficeNvR.vue?vue&type=script&lang=js&"
import style0 from "./OfficeNvR.vue?vue&type=style&index=0&id=34a60abf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports